// extracted by mini-css-extract-plugin
export default {"tasks":"vK-z","task":"wK-z","svg":"xK-z","text":"yK-z"};